import React from 'react';

import { formatMoney } from '@betterment/js-runtime';
import { Icon, ListRow, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

import { ExternalAccountTransactionOptionLink } from './ExternalAccountTransactionOptionLink';
import { HomeExternalAccountsQuery } from './graphql/query.homeExternalAccounts.generated';

import { useColorMode } from '../../Shared/components-v2/color-mode/color-mode-state';
import { urlBuilder } from '../../Shared/urlBuilder';

type Props = { account: HomeExternalAccountsQuery['externalAccounts'][number] };

export const ExternalAccountRow: React.FC<Props> = ({ account }) => {
  const { colorMode } = useColorMode();
  const externalAccountTransactionOptionLink = ExternalAccountTransactionOptionLink({ account });

  return (
    <div className="group">
      <SambaAutoLink to={urlBuilder.appExternalAccounts.absolute()} css={{ _hover: { textDecoration: 'none' } }}>
        <ListRow css={{ py: 'space.300' }}>
          <ListRow.LeadingAsset css={{ width: '36px' }}>
            <img
              src={account.icon[colorMode]}
              alt={`${account.name} icon`}
              className={css({
                width: 'icon.medium',
                borderRadius: 'border.medium',
              })}
            />
          </ListRow.LeadingAsset>
          <ListRow.LeadingContent>
            <Text color="text" css={{ textDecoration: { _groupHover: 'underline', _groupFocus: 'underline' } }}>
              {account.name}
            </Text>
            <Text variant="text50" color="text.weak">
              {account.accountTypeAndRedactedAccountNumber}
            </Text>
          </ListRow.LeadingContent>
          <ListRow.TrailingAsset>
            <Icon name="CaretRight" size="small" color="icon" />
          </ListRow.TrailingAsset>
          <ListRow.TrailingContent>
            <Text variant="text50" color="text">
              {formatMoney(account.balance)}
            </Text>
            <Text variant="text50" color="text.weak">
              {account.lastUpdatedAtDisplay || undefined}
            </Text>
          </ListRow.TrailingContent>
          {externalAccountTransactionOptionLink && (
            <ListRow.BottomContent>{externalAccountTransactionOptionLink}</ListRow.BottomContent>
          )}
        </ListRow>
      </SambaAutoLink>
    </div>
  );
};
